import { useState } from 'react';
import { ImUserPlus } from 'react-icons/im';
import { CdlMenu } from '../../components/CdlMenu/CdlMenu';
import Footer from '../../components/Footer/Footer';
import { Header } from '../../components/Header/Header';
import { Loader } from '../../components/Loader/Loader';
import Sidebar from '../../components/Sidebar/Sidebar';
import { useDevedor } from '../../context/ConsultContext';
import { useLoading } from '../../hooks/useLoading';

import { ConsultationData } from '../ConsultationData/ConsultationData';
import {
  ConsultForm,
  Container,
  Content,
  InputBlock,
} from './styles';

export function Consult() {
  const [devedorCPF, setDevedorCPF] = useState('');
  const [text, setText] = useState('');
  const { mostrarData, getDevedor, showData } = useDevedor();

  const { hideLoader, showLoader, loader } = useLoading();

  async function getDevedorData() {
    showLoader();
    setText('');
    const status = await getDevedor(devedorCPF);
    hideLoader();
    if (status === 200) {
      mostrarData(true);
    } else {
      setText(
        'Esse CPF/CNPJ não foi encontrado, tente novamente ou cadastre no botão "Iniciar cadastro" ',
      );
      mostrarData(false);
    }

    setDevedorCPF('');
  }

  function mask(value: string) {
    if (value.length >= 15) {
      return value
        .replace(/\D/g, '')
        .replace(/^(\d{2})(\d)/, '$1.$2')
        .replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
        .replace(/\.(\d{3})(\d)/, '.$1/$2')
        .replace(/(\d{4})(\d)/, '$1-$2');
    } else {
      return value
        .replace(/\D/g, '')
        .replace(/(\d{3})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d{1,2})/, '$1-$2')
        .replace(/(-\d{2})\d+?$/, '$1');
    }
  }

  return (
    <>
      {!showData ? (
        <Container>
          <Sidebar />
          <Content>
            <Header
              icon={<ImUserPlus color="#A6A6A6" size="32px" />}
              title="Cadastro de Dívidas - Individual"
            >
              <div>
                <CdlMenu page="devedor" />
              </div>
            </Header>
            <hr />
            <ConsultForm
              className="consultation-container"
              hasError={text !== ''}
            >
              <span>{text}</span>
              <InputBlock>
                <p id="title-consult">
                  Informe o CPF/CNPJ que deseja consultar:
                </p>
                <input
                  type="text"
                  placeholder="Digite seu CPF"
                  value={mask(devedorCPF)}
                  maxLength={18}
                  onChange={(e) => setDevedorCPF(e.target.value)}
                />
                <button type="button" onClick={getDevedorData}>
                  Consultar devedor
                </button>
              </InputBlock>
            </ConsultForm>
            {loader && <Loader />}
            <Footer />
          </Content>
        </Container>
      ) : (
        <ConsultationData />
      )}
    </>
  );
}
